import type { SVGProps } from 'react';

export const ControlRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'control remove'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g fill={props.fill}>
        <path d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,1.68421053 C23.9063922,1.68421053 30.3157895,8.09360779 30.3157895,16 C30.3157895,23.9063922 23.9063922,30.3157895 16,30.3157895 C8.09360779,30.3157895 1.68421053,23.9063922 1.68421053,16 C1.68421053,8.09360779 8.09360779,1.68421053 16,1.68421053 Z M23.2489109,15.2 L8.7,15.2 L8.7,16.7841584 L23.2489109,16.7841584 L23.2489109,15.2 Z" />
      </g>
    </g>
  </svg>
);
